import { ProgressiveAssetController } from './ProgressiveAssetController';
import { ProgressiveAssetImage } from './ProgressiveAssetImage';
import { ProgressiveAssetSkeleton } from './ProgressiveAssetSkeleton';
import { ProgressiveAssetVideo } from './ProgressiveAssetVideo';
import * as ProgressiveAssetStyles from './styles';
export { ProgressiveAssetVideo, ProgressiveAssetSkeleton, ProgressiveAssetStyles };
export const ProgressiveAsset = {
    Image: ProgressiveAssetImage,
    Skeleton: ProgressiveAssetSkeleton,
    Video: ProgressiveAssetVideo,
    Styles: ProgressiveAssetStyles,
    Controller: ProgressiveAssetController,
};
//# sourceMappingURL=index.js.map